




































import {
  DiscordUserInterface,
  PersistedEventInterface,
  UserPromotionListEntry,
} from "@/types";
import Vue from "vue";
import Component from "vue-class-component";
import { PropSync } from "vue-property-decorator";
import Discord from "../../../Discord";

@Component
export default class UserPromotionLeaderboard extends Vue {
  @PropSync("selectedEvent", { type: Object, default: null })
  public syncedSelectedEvent!: PersistedEventInterface | null;

  @PropSync("userPromotionList", { type: Array, default: () => [] })
  public syncedUserPromotionList!: UserPromotionListEntry[];

  public leaderboardSearch: string = "";
  public leaderboardHeaders = [
    { text: "Rank", value: "rank", sortable: false },
    { text: "Messenger", value: "messagedBy", sortable: false },
    { text: "Players Messaged", value: "uniquePlayersMessaged", sortable: false },
    { text: "Converted", value: "converted", sortable: false },
  ];

  public isSignedUp(userId: string, eventName: string): boolean {
    if (!this.syncedSelectedEvent || !this.syncedSelectedEvent.slotGroups) {
      return false;
    }

    // Loop through all slot groups and their slots
    const isSignedUp = this.syncedSelectedEvent.slotGroups.some((slotGroup) => {
      return slotGroup.playerSlots.some((slot) => {
        // Compare as strings to handle large Discord IDs
        return slot.discordUser && String(slot.discordUser.id) === String(userId);
      });
    });

    return isSignedUp;
  }

  public getMessengerAvatar(messenger: DiscordUserInterface): string {
    return Discord.avatarSourceUri(messenger.id, messenger.avatar);
  }

  public get leaderboardKey(): string {
    // Create a unique key based on event and list length to force re-render when data changes
    const eventId = this.syncedSelectedEvent?.id || "none";
    const listLength = this.syncedUserPromotionList?.length || 0;
    return `${eventId}-${listLength}`;
  }

  public get leaderboard() {
    if (!this.syncedSelectedEvent) {
      return [];
    }

    if (!this.syncedUserPromotionList || this.syncedUserPromotionList.length === 0) {
      return [];
    }

    const eventName = this.syncedSelectedEvent.name;
    const messengerMap = new Map<
      string,
      { userIds: Set<string>; convertedUserIds: Set<string>; user: DiscordUserInterface }
    >();

    // Iterate through all users and their promotion messages
    this.syncedUserPromotionList.forEach((user) => {
      user.promotionMessages.forEach((message) => {
        // Only count messages for the selected event
        if (message.event === eventName && message.messagedBy) {
          const messengerKey = String(message.messagedBy.id);
          if (!messengerMap.has(messengerKey)) {
            messengerMap.set(messengerKey, {
              userIds: new Set(),
              convertedUserIds: new Set(),
              user: message.messagedBy,
            });
          }
          // Add the user ID to the set (automatically handles uniqueness)
          messengerMap.get(messengerKey)!.userIds.add(user.id);

          // Check if the user signed up for the event (converted)
          if (this.isSignedUp(user.id, eventName)) {
            messengerMap.get(messengerKey)!.convertedUserIds.add(user.id);
          }
        }
      });
    });

    // Convert map to array and sort by converted count descending
    const leaderboardData = Array.from(messengerMap.entries()).map(([username, data]) => ({
      messagedBy: data.user,
      uniquePlayersMessaged: data.userIds.size,
      converted: data.convertedUserIds.size,
    }));

    const sorted = leaderboardData.sort((a, b) => b.converted - a.converted);

    // Add rank to each entry
    return sorted.map((entry, index) => ({
      ...entry,
      rank: index + 1,
    }));
  }
}
